import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { bool } from 'prop-types';
import { ProjectsRecapCard } from '@thd-olt-component-react/project-summary';
import { ProductList } from '../product-list/product-list';
import { JobQuotesCard } from '../job-quotes/job-quotes';
export var DashboardPlanYourJobs = function (_a) {
    var isB2B = _a.isB2B, hasProjectBenefit = _a.hasProjectBenefit;
    var theme = useTheme(DashboardPlanYourJobs);
    var hideJobQuotesCard = theme.props.hideJobQuotesCard;
    return (React.createElement("div", null,
        React.createElement(Typography, { variant: "h2", weight: "display", "data-testid": "plan-your-jobs-title" }, "Plan Your Jobs"),
        isB2B && hasProjectBenefit && (React.createElement("div", { className: "sui-mt-8", "data-testid": "projects-recap-card" },
            React.createElement(ProjectsRecapCard, { isValidCustomer: hasProjectBenefit }))),
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 sui-gap-x-0 sui-gap-y-4 sm:sui-gap-x-4 md:sui-gap-x-8 md:sui-gap-y-8 sui-mt-6" },
            !hideJobQuotesCard && (React.createElement("div", { className: "sui-col-span-1", "data-testid": "job-quotes-card" },
                React.createElement(JobQuotesCard, null))),
            React.createElement("div", { className: "sui-col-span-1", "data-testid": "product-list-card" },
                React.createElement(ProductList, null)))));
};
DashboardPlanYourJobs.displayName = 'DashboardPlanYourJobs';
DashboardPlanYourJobs.themeProps = {
    hideJobQuotesCard: bool,
};
DashboardPlanYourJobs.defaultThemeProps = {
    hideJobQuotesCard: false,
};
